import { RoomApiRoomListRequest } from "../../openapi";
import appApiClient from "./coreApiClient";
import useBaseQuery from "./useBaseQuery";

export const useRoomListQuery = (req: RoomApiRoomListRequest) =>
  useBaseQuery({
    queryKey: ["roomList"],
    queryFn: (config) => appApiClient.roomApi.roomList(req, config),
  });
